import { Card, styled } from "@mui/material";

export const ContentTabStyleCard = styled(Card)(() => ({
  width: "100%",
  maxWidth: "100%",
  height: "52rem",
  display: "flex",
  flexWrap: "wrap",
  alignContent: "center",
  border: "none",
  boxShadow: "none",
  paddingTop: "9px",
}));

export const TabstyledCard = styled(Card)(({ theme }) => ({
  width: "99%",
  height: "100%",
  marginBottom: "1rem",
  marginLeft: "4px",
  padding: theme.spacing(2),
  boxShadow: theme.shadows[3],
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
}));
